import { HTMLAttributes, memo } from "react";
import classNames from "classnames";

import { ReactComponent as FileIcon } from "./icons/file.svg";

import styles from "./styles.module.scss";

export type EmptyStateFileTypeIconProps = HTMLAttributes<HTMLDivElement>

export const EmptyStateFileTypeIcon = memo<EmptyStateFileTypeIconProps>(({ className, ...props }) => {
  return (
    <div
      {...props}
      className={classNames(className, styles.root)}
    >
      <FileIcon />
    </div>
  );
});